import Utils from '@/scripts/Utils';
import Rules from "@/utils/Rules";
import HydrometerService from "@/services/server/HydrometersService";
import { showErrorSnackBar, showSuccessSnackBar,showInfoSnackBar } from "@/utils/SnackBartHelper";
import { showDeleteDialogAlert } from "@/utils/DialogAlertHelper";
import InputMoney from "@/components/Forms/Input/input-money.vue";

export default {
  name: "HydrometerService",
  components: {
    InputMoney,
  },
  data: () => ({
    page: 1,
    newItem: {
      name: "",
      model: "",
      description: "",
      litersPerPulse: "",
    },
    dataHydrometers: [],
    dataGroups: [],
    dataPoints: [],
    validForm: true,
    saveButtonLoading: false,
    isLoadingSolution: false,
    isLoadingSolutionForm: false,
    loadingSelectGroup: false,
    loadingSelectPoint: false,
    dialogSolution: false,
    menuOpen: false,
    columnsToChoose: [{ text: "Name", value: "name" },
    { text: "Modelo", value: "model" }],
    columnToSeach: "name",
    headers: [
      { text: "Nome", value: "name"},
      { text: "Modelo", value: "model"},
      { text: "Litro / Pulso", value: "litersPerPulse"},
      { text: "Ações", value: "actions", sortable: false },
    ],
    searchText: "",
    formTitle: "Adicionar Hidrometro",
    deleteItem: null,
  }),
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    async listSolutions() {
      this.loadingSelectGroup = true
      const response = await HydrometerService.findAll()
      this.dataHydrometers = response.data.data
      this.loadingSelectGroup = false
    },
    closeDialog() {
      this.dialogSolution = false
    },
    openSolutionDialog(item = null) {
      this.dialogSolution = true
      this.newItem = {}
      if (item) {
        this.formTitle = "Editar Hidrometro"
        this.newItem = item
      } else {
        this.formTitle = "Adicionar Hidrometro"
      }
    },
    async saveSolution() {
      if (this.$refs.addSolutionForm && !this.$refs.addSolutionForm.validate()) return;
      this.isLoadingSolutionForm = true
      try {
        if (this.formTitle === "Editar Hidrometro") {
          await this.editHydrometer()
        } else if (this.formTitle === "Adicionar Hidrometro") {
          await this.createHydrometer()
        }
      } catch (err) {
        console.error(err)
        showErrorSnackBar("Ocorreu um erro interno!. Entre em contato com nossa equipe.")
      } finally {
        this.closeDialog();
        this.isLoadingSolutionForm = false
      }
    },
    async createHydrometer() {
      try {
        const response = await HydrometerService.create({ ...this.newItem,litersPerPulse:  Number(this.newItem.litersPerPulse)})
        this.dataHydrometers.unshift(response.data.data)
        showSuccessSnackBar("Hidrometro cadastrada com sucesso!")
      } catch (err) {
        throw "Ocorreu um erro ao Criar Hidrometro!"
      }
    },
    async editHydrometer() {
      try {
        const response = await HydrometerService.update(this.newItem.id, {...this.newItem,litersPerPulse:  Number(this.newItem.litersPerPulse)})
        this.dataHydrometers = this.dataHydrometers.map((solution) => solution.id === this.newItem.id ? response.data.data : solution)
        showSuccessSnackBar("Hidrometro editada com sucesso!")
      } catch (err) {
        throw "Ocorreu um erro ao Editar Hidrometro!"
      }
    },
    async confirmDeleteHydrometer(item) {
      this.deleteItem = item
      showDeleteDialogAlert(`Deseja excluir esse hidrômetro ${item.name}?`, this.deleteHydrometer)
    },
    async deleteHydrometer() {
      try {
        this.isLoadingSolution = true
        await HydrometerService.remove(this.deleteItem.id)
        this.dataHydrometers = this.dataHydrometers.filter((solution) => this.deleteItem != solution)
      } catch (err) {
        console.error(err)
        const message = err?.response?.data?.message
        if (!message) showErrorSnackBar("Ocorreu um erro interno!. Entre em contato com nossa equipe.")
      }
      this.deleteItem = null
      this.isLoadingSolution = false
    },
    changeIDGroupPerName(id_group) {
      if(this.dataGroups.length){
        const group =  this.dataGroups.filter(({id}) => id === id_group)
        if(group.length) return group[0].name
        else return " - / - "
      }
      
    },
    changeIDPointPerName(id_point) {
      if(this.dataPoints.length){
        const point =  this.dataPoints.filter(({id}) => id === id_point)
        if(point.length) return point[0].name
        else return " - / - "
      }
      
    },

    changeIdPerName(columSearch,value){
      let name = ""
      switch (columSearch) {
        case "groupId":
          name = this.changeIDGroupPerName(value)
          return name
        case "pointId":
          name = this.changeIDPointPerName(value)
          return name
        default:
          return value
      }
    }
  },
  computed: {
    filterSoluitions() {
      let text = Utils.defaultSpace(this.searchText)
      let list = this.dataHydrometers
      list = list.filter((solution) => {
        let value = ""
        if(solution[this.columnToSeach]) value = this.changeIdPerName(this.columnToSeach,solution[this.columnToSeach])
        if (value) return (Utils.defaultSpace(value).toLowerCase().indexOf(text.toLowerCase()) > -1);
        else return ""
      });
      return list
    },
    rulesRequired() {
      return Rules.required();
    },
    getSolutionsGroupsByType(){
      if(this.newItem.type){
        const groups = this.dataGroups.filter(({type}) => type === this.newItem.type)
        if(!groups.length) showInfoSnackBar(`Não existem grupos cadastrados para o tipo ${this.newItem.type}`)
        return this.dataGroups.filter(({type}) => type === this.newItem.type)
      }
    }
  },
  mounted() {
    this.listSolutions();
  },
};
